import { useNetwork } from '../contexts/NetworkContext'
import { WifiOff, Wifi } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function NetworkStatus() {
  const { isOnline } = useNetwork()
  const [showReconnected, setShowReconnected] = useState(false)
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    if (!isOnline) {
      // オフラインになった
      setWasOffline(true)
      setShowReconnected(false)
    } else if (wasOffline && isOnline) {
      // オフラインから復帰した
      setShowReconnected(true)
      setWasOffline(false)

      // 3秒後に「再接続しました」メッセージを非表示
      const timer = setTimeout(() => {
        setShowReconnected(false)
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [isOnline, wasOffline])

  // オンラインで、再接続メッセージも表示不要なら何も表示しない
  if (isOnline && !showReconnected) {
    return null
  }

  return (
    <>
      {/* オフライン表示 */}
      {!isOnline && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
            <WifiOff className="h-5 w-5" />
            <span className="text-sm font-medium">
              オフラインモード - インターネット接続がありません
            </span>
          </div>
        </div>
      )}

      {/* 再接続表示 */}
      {showReconnected && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-green-600 text-white py-2 px-4 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
            <Wifi className="h-5 w-5" />
            <span className="text-sm font-medium">
              オンラインに戻りました
            </span>
          </div>
        </div>
      )}
    </>
  )
}
